import { createContext } from 'react'

export const AdminProductsOrder = createContext(null)